import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { BreadcrumbService } from '@lbca-shared/breadcrumb';
import { MOCK_VERTICALS } from 'services/navigation.const';

/** Só casa `/:verticalSlug/...` quando o slug é uma vertical conhecida — o resto cai no 404 */
export const verticalCanMatch: CanMatchFn = (_route, segments) =>
	!!MOCK_VERTICALS[segments[0]?.path ?? ''];

/** Mostra o nome da vertical no breadcrumb (ex.: Início › Trabalhista › Contestação) */
export const verticalBreadcrumbGuard: CanActivateFn = (route) => {
	const slug = route.params['verticalSlug'] as string;
	inject(BreadcrumbService).set(`/${slug}`, MOCK_VERTICALS[slug]?.name ?? slug);
	return true;
};
